import { PageHero } from "@/src/components/PageHero";
import { StoryContent } from "./(sections)/StoryContent";
import { ProcessSteps } from "./(sections)/ProcessSteps";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function OurStoryPage() {
    return (
        <>
            <PageHero
                image="https://images.unsplash.com/photo-1508193638397-1c4234db14d8?auto=format&fit=crop&q=80&w=2000"
                label="Who we are"
                title="Our Story"
            />
            <StoryContent />
            <ProcessSteps />
            <Newsletter />
        </>
    );
}
